var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJardinier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19988"
    },
    d: "M397.758,324H114.275c-19.315,0-37.451,7.096-51.065,20.554C49.532,358.075,42,375.825,42,395.109 V496.03c0,8.268,6.716,15.97,15,15.97h397c8.284,0,15-7.702,15-15.97V395.109C469,354.88,437.707,324,397.758,324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD9E"
    },
    d: "M256.063,324H114.275c-19.315,0-37.451,7.096-51.065,20.554C49.532,358.074,42,375.824,42,395.109 V496.03c0,8.268,6.716,15.97,15,15.97h199.063V324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8CFD6"
    },
    d: "M395.969,404.471c-21.267-15.832-35.515-39.457-41.201-68.444 C353.389,329.001,347.22,324,340.047,324H171.953c-7.173,0-13.342,5.001-14.721,12.027c-5.687,28.987-19.935,52.645-41.201,68.477 c-3.795,2.826-6.031,7.24-6.031,11.967v80.058c0,8.268,6.716,15.471,15,15.471h262c8.284,0,15-7.203,15-15.471v-80.058 C402,411.745,399.764,407.296,395.969,404.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF6FA"
    },
    d: "M256,324h-84.047c-7.173,0-13.342,5.001-14.721,12.027c-5.687,28.987-19.935,52.645-41.201,68.477 c-3.795,2.825-6.031,7.24-6.031,11.967v80.059c0,8.268,6.716,15.471,15,15.471h131V324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D19988"
    },
    d: "M342.417,144H169.583c-8.284,0-14.583,6.649-14.583,14.917v85.447c0,31.732,19.362,59.247,47,70.755 v58.151c0,24.765,19.825,45.73,44.639,45.73h17.92C289.372,419,310,398.035,310,373.27v-58.201c27.646-11.539,47-39.021,47-70.705 v-85.447C357,150.649,350.701,144,342.417,144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD9E"
    },
    d: "M256,144h-86.417c-8.284,0-14.583,6.649-14.583,14.917v85.447c0,31.732,19.362,59.247,47,70.755 v58.151c0,24.765,19.825,45.73,44.639,45.73H256C256.147,419,256,144,256,144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A15E"
    },
    d: "M467.909,156.905l-123.909-53V65.549C344,28.854,314.066,0,277.273,0h-42.378 C198.009,0,168,28.854,168,65.549v38.356l-123.909,53c-6.546,2.8-10.217,9.989-8.784,16.952C36.738,180.82,42.878,186,50,186h412 c7.122,0,13.262-5.18,14.693-12.142C478.126,166.895,474.455,159.705,467.909,156.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6AC473"
    },
    d: "M256,0h-21.104C198.009,0,168,28.854,168,65.549v38.356l-123.909,53 c-6.546,2.8-10.217,9.989-8.784,16.952C36.738,180.82,42.878,186,50,186h206V0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC77D"
    },
    d: "M467.909,156.905l-123.909-53V103H168v0.905l-123.909,53c-6.546,2.8-10.217,9.989-8.784,16.952 C36.738,180.82,42.878,186,50,186h412c7.122,0,13.262-5.18,14.693-12.142C478.126,166.895,474.455,159.705,467.909,156.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE57D"
    },
    d: "M256,103h-88v0.905l-123.909,53c-6.546,2.8-10.217,9.989-8.784,16.952 C36.738,180.82,42.878,186,50,186h206V103z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJardinier);
export default __webpack_public_path__ + "static/media/jardinier.fdfed5dd.svg";
export { ForwardRef as ReactComponent };